import { useMutation, type UseMutationResult } from '@tanstack/react-query'
import { inviteService } from '@/services/InviteService'
import type { LoginResponseDto } from '@lib/dto/auth.dto'
import type { AcceptInviteInput } from '@lib/input/invite.input'

/**
 * Claim an invite. The token is bound at hook-construction time so the caller's
 * submit handler only supplies the form values.
 *
 * Deliberately does NOT adopt the returned session itself — the page does that
 * via `useAuth().adoptSession`, keeping session side effects in one place
 * rather than hidden inside a mutation.
 */
export function useAcceptInvite(
  token: string,
): UseMutationResult<LoginResponseDto, Error, AcceptInviteInput> {
  return useMutation({
    mutationFn: (input: AcceptInviteInput) =>
      inviteService.accept(token, input),
  })
}
